import { type WorkspaceMemberView, WorkspaceRoleEnum } from '@schemas/workspace'

// RAL-121 rule 6: a refusal names who can act, by name where known. `User` carries no display
// name yet, so "by name" is the email address — see the PR note on where a real name would read
// better than jules@midnighttour.com.
//
// Module scope because Intl constructors are expensive and this renders per refusal and per
// roster. 'en' is explicit: the copy around it is English, so a German locale must not turn
// "or" into "oder" mid-sentence.
const adminList = new Intl.ListFormat('en', { style: 'long', type: 'disjunction' })

// Two names read as a sentence ("Jules or Marco can approve"); a seven-admin workspace does not.
const MAX_NAMED = 2

export const adminEmails = (members: readonly WorkspaceMemberView[]): string[] => {
  const emails: string[] = []
  for (const member of members) {
    if (member.role === WorkspaceRoleEnum.enum.admin) emails.push(member.email)
  }
  return emails
}

/** "jules@… or marco@…", or null when the roster isn't available — the caller falls back to "an admin". */
export const namedAdmins = (emails: readonly string[]): string | null => {
  if (emails.length === 0) return null
  if (emails.length <= MAX_NAMED) return adminList.format(emails)
  const rest = emails.length - MAX_NAMED
  return adminList.format(emails.slice(0, MAX_NAMED).concat(`${rest} ${rest === 1 ? 'other' : 'others'}`))
}
